import { Flex, Text } from "@mantine/core";
import Link from "next/link";
import { memo } from "react";
import { MdLightbulbOutline } from "react-icons/md";
import { AvatarIconMemo } from "src/component/element/AvatarIcon";
import { RankingScoreIcon } from "src/component/element/RankingItem/RankingScoreIcon";
import type { FumufumuRanking } from "src/service/RankingApi/types";

import styles from "./RankingItem.module.scss";

const MyFumufumuRankingItem = ({ rank, score, user }: FumufumuRanking) => {
  return (
    <Link
      className={styles.rankingMyItem}
      href={`/mypage`}
      passHref
      aria-label="マイページへ遷移"
    >
      <Flex align="center">
        <div className={styles.rankingNumber}>
          <RankingScoreIcon rank={rank} />
          <p className={rank <= 3 ? styles.rankNumberWhite : styles.rankNumber}>
            {rank}
          </p>
        </div>
        <div className={styles.avatarWrap}>
          <AvatarIconMemo
            avatar={user.profileImage}
            background={user.profileBgImage}
          />
        </div>

        <div className={styles.rankingTexts}>
          <Text size={12}>{user?.nickname}</Text>
        </div>
        <Flex
          align="center"
          justify="space-between"
          gap={4}
          className={styles.niceWrap}
        >
          <MdLightbulbOutline size={20} style={{ width: "40%" }} />
          <Text className={styles.score}>{score}</Text>
        </Flex>
      </Flex>
    </Link>
  );
};

export const MyFumufumuRankingItemMemo = memo(MyFumufumuRankingItem);
